import { cn } from '@workspace/ui/lib';

interface ListItemProps {
  title: string;
  id: string;
  value?: string;
  onChange?: (id: string) => void;
  icon?: React.ReactNode;
  titleDescription?: string;
  actionDescription?: string;
  actionItems?: React.ReactNode;
  hasPointerEvents?: boolean;
}
const ListItem = ({
  id,
  value,
  title,
  icon,
  titleDescription,
  actionDescription,
  actionItems,
  hasPointerEvents = false,
  onChange,
}: ListItemProps) => {
  const isSelected = value === id;

  return (
    <div
      className="group border-grey-200 dark:border-grey-700 border-b"
      key={id}
      onClick={hasPointerEvents && onChange ? () => onChange(id) : undefined}
      role={hasPointerEvents && onChange ? 'button' : undefined}
      tabIndex={hasPointerEvents && onChange ? 0 : undefined}
      onKeyDown={
        hasPointerEvents && onChange
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onChange(id);
              }
            }
          : undefined
      }
      aria-selected={isSelected}
    >
      <div
        className={cn(
          'group flex justify-between',
          hasPointerEvents
            ? 'hover:bg-grey-100 dark:hover:bg-grey-900 my-2 cursor-pointer rounded-2xl px-3 py-3'
            : 'pt-3 pb-4',
          isSelected && hasPointerEvents && 'bg-grey-100 dark:bg-grey-900'
        )}
      >
        <div className="flex h-7 items-center gap-2 align-middle">
          {icon && icon}
          <div
            className={cn(
              'text-grey-800 dark:text-grey-300 text-base leading-none font-normal',
              hasPointerEvents &&
                'group-hover:font-medium group-hover:text-neutral-200 dark:group-hover:text-neutral-100',
              isSelected && 'font-medium text-neutral-200 dark:text-neutral-100'
            )}
          >
            {title}
          </div>
          {titleDescription && (
            <div className="text-grey-600 dark:text-grey-200 text-sm leading-none font-normal">
              {titleDescription}
            </div>
          )}
        </div>
        <div className="flex h-7 items-center gap-2 align-middle">
          {actionDescription && (
            <div className="text-grey-800 dark:text-grey-300 text-sm leading-none font-normal">
              {actionDescription}
            </div>
          )}
          {actionItems && actionItems}
        </div>
      </div>
    </div>
  );
};

export { ListItem };
